import styled from "styled-components"

export interface CardProps {
  background_color: string
}

export interface FontColorProps {
  font_color: string
}

export const StyledCardResearch = styled.div<CardProps>`
  background: ${(props) =>
    props.background_color === "white" && props.theme.colors.white};
  background: ${(props) =>
    props.background_color === "ivory" && props.theme.colors.ivory};
  background: ${(props) =>
    props.background_color === "ivory_dark" && props.theme.colors.ivoryShadow};
  background: ${(props) =>
    props.background_color === "light_pink" && props.theme.colors.pinkLight};
  background: ${(props) =>
    props.background_color === "pink" && props.theme.colors.pink};
  background: ${(props) =>
    props.background_color === "dark_pink" && props.theme.colors.pinkDark};
  background: ${(props) =>
    props.background_color === "light_green" && props.theme.colors.greenLight};
  background: ${(props) =>
    props.background_color === "green" && props.theme.colors.green};
  background: ${(props) =>
    props.background_color === "dark_green" && props.theme.colors.greenDark};
  background: ${(props) =>
    props.background_color === "light_blue" && props.theme.colors.blueLight};
  background: ${(props) =>
    props.background_color === "blue" && props.theme.colors.blue};
  background: ${(props) =>
    props.background_color === "dark_blue" && props.theme.colors.blueDark};
  border-radius: 30px;
  height: fit-content;
`

export const StyledCardResearchContainer = styled.div`
  padding: 32px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 24px;
  }
`

export const StyledCardResearchTitle = styled.h2`
  font-family: ${(props) => props.theme.fonts.circularBook};
  text-transform: uppercase;
  margin-bottom: 0;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 22px;
    line-height: 26px;
  }
`

export const StyledCardResearchSource = styled.p`
  margin-top: 8px;
  font-family: ${(props) => props.theme.fonts.circularItalic};
  font-size: 18px;
  color: ${(props) => props.theme.colors.darkGrey};

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    font-size: 16px;
  }
`

export const StyledCardResearchCategory = styled.p`
  text-transform: uppercase;
  font-size: 14px;
  margin-bottom: 16px;
`

export const StyledCardResearchAuthor = styled.p`
  text-transform: uppercase;
  font-family: ${(props) => props.theme.fonts.circularBold};
  margin-bottom: 0;
  color: ${(props) => props.theme.colors.darkGrey};
`

export const StyledCardResearchYear = styled.p`
  margin-top: 0;
  color: ${(props) => props.theme.colors.darkGrey};
  font-family: ${(props) => props.theme.fonts.circularItalic};
`

export const StyledButton = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 32px;

  .button-v2 {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.circularMedium};
  }
`

export const StyledCardResearchText = styled.div<FontColorProps>`
  h2 {
    color: ${(props) =>
      props.font_color === "white" && props.theme.colors.white};
  }

  p {
    color: ${(props) =>
      props.font_color === "white" && props.theme.colors.white};
  }
`

// CARD RESEARCH SMALL

export const StyledCardResearchSmall = styled.div`
  border-top: 1px solid ${(props) => props.theme.colors.darkGrey};
  padding: 8px 32px 0 0;
`

export const StyledCardSmallContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const StyledCardResearchSmallTitle = styled.h2`
  font-family: ${(props) => props.theme.fonts.circularBook};
  font-size: 22px;
  line-height: 26px;
  margin-bottom: 8px;
`

export const StyledCardResearchSmallAuthor = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors.darkGrey};
`

export const StyledButtonSmall = styled.div`
  padding-top: 16px;

  .button-v2 {
    text-transform: uppercase;
    font-family: ${(props) => props.theme.fonts.circularMedium};
  }
`

// CARD ICON

export const StyledCard = styled.div`
  background: ${(props) => props.theme.colors.white};
  border-radius: 30px;
`

export const StyledCardContainer = styled.div`
  padding: 64px 32px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    padding: 48px 24px;
  }
`

export const StyledCardIcon = styled.img`
  max-width: 64px;
  max-height: 64px;
  margin-bottom: 24px;

  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    max-width: 48px;
    max-height: 48px;
  }
`

export const StyledCardResearchDescription = styled.p`
  padding-top: 8px;
  margin: 0;
  color: ${(props) => props.theme.colors.darkGrey};
`
